module.exports = __webpack_public_path__ + "media/images/edit pencil-aa105ffa8cc04c74389102d044f8f1bb.png";